import { FILE_MIME_TYPES } from "../fileTypes/fileTypes";

const validInspectionFileTypes = [
  FILE_MIME_TYPES.PNG,
  FILE_MIME_TYPES.JPG,
  FILE_MIME_TYPES.JPEG,
  FILE_MIME_TYPES.GIF,
  FILE_MIME_TYPES.PDF,
  FILE_MIME_TYPES.DOC,
  FILE_MIME_TYPES.DOCX,
  FILE_MIME_TYPES.XLS,
  FILE_MIME_TYPES.XLSX,
  FILE_MIME_TYPES.CSV,
];
export { validInspectionFileTypes };
